import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2b975f9e&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=2b975f9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b975f9e",
  null
  
)

export default component.exports